import Typography from '@mui/material/Typography';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(16)};

  height: 100dvh;
  width: 100vw;
  padding: ${({ theme }) => theme.spacing(6)};
`;

export const LeftColumn = styled.div`
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(10)};

  min-width: 0;
  width: 32rem;
  max-width: 32rem;
`;

export const RightColumn = styled.div`
  flex-shrink: 1;
  display: none;

  min-width: 0;

  ${({ theme }) => theme.breakpoints.up(768)} {
    display: flex;
  }
`;

export const Graphic = styled.img`
  width: 404px;
  max-width: 100%;
  height: auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(8)};
`;

export const Logo = styled.img`
  align-self: flex-start;
  flex-shrink: 0;
`;

export const Titles = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2.5)};
`;

export const Title = styled(Typography)`
  font-size: 32px;
  line-height: 130%;
`;

export const Options = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(5)};
  width: 100%;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const LinkButton = styled.button`
  padding: 0;
  border: none;
  background: none;

  color: ${({ theme }) => theme.palette.primaryExtended.opacityBackgroundText};
  font: inherit;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
